module.exports = __webpack_public_path__ + "img/full6-min.cba31edd.png";